export enum MemoType {
    Memo = 0,
    Action = 1
}
